import React from 'react';
import cssClasses from './row.css';
import Cell from './Cell/Cell';
import isEqual from 'lodash.isequal';
import { ContextMenuTrigger } from "react-contextmenu";

const propsAreEqual = (prev, next) => {
    return !next.rowUpdated
        && prev.focusedCell.coords.x !== prev.index
        && next.focusedCell.coords.x !== prev.index
        && isEqual(prev.columns, next.columns);
}

const collect = (props) => {
    return props;
}

const Row = (props) => {
    // console.log(`Row rendered`,props.index);

    const isDisabledCell = (row, columnId) => {
        const disabledCellChecker = props.disabledCellChecker;

        if (disabledCellChecker)
            if (disabledCellChecker(row, columnId))
                return true;
        return false;
    }

    const row = props.rows[props.index];
    const trClasses = [cssClasses.row];
    if (props.index % 2 !== 0) trClasses.push(cssClasses.odd)
    return <ContextMenuTrigger id={props.contextMenuId} row={props.rows[props.index]} collect={collect}>
        <div className={trClasses.join(' ')} data-row-key={props.getRowKey(row)} data-x={props.index} id={'Row-' + props.index} key={'Row-' + props.index} style={props.style}>
            {props.columns.map((column, y) => {
                return <Cell
                    y={y}
                    column={column}
                    row={row}
                    rowsCount={props.rows.length}
                    columnsCount={props.columns.length}
                    height={props.height}
                    rowheight={props.rowheight}
                    columnWidthList={props.columnWidthList}
                    focusedCell={props.focusedCell}
                    setCellDirectly={props.setCellDirectly}
                    resizingColumn={props.resizingColumn}
                    index={props.index}
                    key={`X-${props.index}_Y-${y}`}
                    disabled={isDisabledCell(row, column.id)}
                    rowUpdated={props.rowUpdated}
                ></Cell>
            })}
        </div>
    </ContextMenuTrigger>;
}

export default React.memo(Row, propsAreEqual);



// WEBPACK FOOTER //
// ./src/components/DataTable/Body/Row/row-nolazy.js